import { render, staticRenderFns } from "./awardPopup.vue?vue&type=template&id=0a0316ce&scoped=true"
import script from "./awardPopup.vue?vue&type=script&lang=js"
export * from "./awardPopup.vue?vue&type=script&lang=js"
import style0 from "./awardPopup.vue?vue&type=style&index=0&id=0a0316ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0316ce",
  null
  
)

export default component.exports